import Vue from 'vue'
import { formatDatesForRequest } from '@/utils'

import app from '@/main'

const salesFunnelAnalyticsModule = {
  namespaced: true,
  state: {
    period: {
      start: null,
      end: null
    },
    data: null,
    loading: false
  },

  mutations: {
    setLoading: (state, loading) => (state.loading = loading),
    setPeriod: (state, period) => (state.period = period),
    setData: (state, data) => (state.data = data)
  },

  actions: {
    FETCH_SALES_FUNNEL_ANALYTICS: async ({ dispatch, rootGetters }, period) => {
      const params = {
        start: formatDatesForRequest(period.start),
        end: formatDatesForRequest(period.end)
      }

      try {
        const response = await Vue.http.get(`${rootGetters.getBackendUrl}/analytics/sales_funnel`, {
          params,
          headers: rootGetters.getAllResponseHeaders
        })

        if (response.status === 200) {
          const { result_id, result_type } = response.body

          try {
            const task_result = await dispatch(
              'GET_TASK_RESULT',
              {
                result_id,
                result_type
              },
              {
                root: true
              }
            )

            if (task_result.body.ready === true) {
              return task_result.body.result.chart_data
            }
          } catch (e) {
            throw e
          }
        }
      } catch (e) {
        app.$raven.captureException(e)
      }
    },
    GET_SALES_FUNNEL_ANALYTICS: async ({ dispatch, commit, state, rootState }, period) => {
      if (state.loading) return

      if (
        rootState.desktop.salesFunnel.data &&
        period.start === rootState.desktop.salesFunnel.period.start &&
        period.end === rootState.desktop.salesFunnel.period.end
      ) {
        commit('setData', rootState.desktop.salesFunnel.data)
        commit('setPeriod', JSON.parse(JSON.stringify(rootState.desktop.salesFunnel.period)))
        return
      }

      try {
        commit('setLoading', true)
        const data = await dispatch('FETCH_SALES_FUNNEL_ANALYTICS', period)
        commit('setData', data)
        commit('setPeriod', JSON.parse(JSON.stringify(period)))
        commit('setLoading', false)
      } catch (e) {
        app.$raven.captureException(e)
        app.$message('danger', e.statusText || 'Error')
      }
    }
  }
}

export default salesFunnelAnalyticsModule



// WEBPACK FOOTER //
// ./src/store/modules/analytics/modules/sales_funnel.js